import React from 'react';
import ArticleList from './ArticleList.jsx';
import FeedContainerBig from './FeedContainerBig.jsx';
import _ from 'lodash';

const StandardNews = ({ articles, showExtraBanner }) =>
    <ArticleList articles={_.tail(articles)}>
        <div className="row">

            <div className="template-item col-md-12">
                <FeedContainerBig contentContainer={_.first(articles)}
                    showExtraBanner={showExtraBanner} />
            </div>
        </div>
    </ArticleList>;

export default StandardNews;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/StandardNews.jsx